"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _nano = require("./nano");
var _variables = require("./variables");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var alertContainerHeight = '40px';
var alertIconWidth = alertContainerHeight;
var fontSize = '16px';
var _default = exports["default"] = (0, _nano.sheet)(_objectSpread({
  container: {
    position: 'fixed',
    top: '50px',
    left: '50%',
    width: '50%',
    height: alertContainerHeight,
    transform: 'translateX(-50%)',
    zIndex: _variables.zIndexes.get('alert')
  },
  alert: {
    width: '100%',
    backgroundColor: '#fff',
    color: '#000',
    padding: 0,
    borderRadius: 'inherit',
    margin: 0,
    boxShadow: '1px 1px 10px 1px',
    zIndex: _variables.zIndexes.get('above-siblings')
  },
  alert__title: {
    display: 'flex',
    flex: 1,
    marginLeft: '10px',
    fontSize: fontSize
  },
  alert__actions: {
    display: 'flex',
    maxHeight: '100%',
    margin: 0,
    '& button': {
      minWidth: '24px'
    }
  },
  close: {
    '&::before': {
      fontSize: '1rem'
    }
  },
  alert__content: {
    display: 'flex',
    flexDirection: 'column',
    height: alertContainerHeight
  },
  alert__content_expanded: {
    height: 'auto',
    '& .alert__message': {
      height: 'auto'
    },
    '& .alert__details': {
      display: 'flex',
      width: 'auto',
      overflow: 'hidden'
    }
  },
  alert__message: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: alertContainerHeight
  },
  alert__icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'baseline',
    width: alertIconWidth,
    height: alertIconWidth,
    color: '#fff',
    padding: 0,
    fontSize: '1.5rem',
    fontWeight: 'bold'
  },
  alert__details: {
    display: 'none',
    padding: '10px 0',
    paddingLeft: '5px',
    marginLeft: alertIconWidth,
    whiteSpace: 'pre-line',
    wordWrap: 'break-word'
  }
}, (0, _toConsumableArray2["default"])(_variables.uiMessaging.entries()).reduce(function (p, _ref) {
  var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
    k = _ref2[0],
    data = _ref2[1];
  return _objectSpread(_objectSpread({}, p), {}, (0, _defineProperty2["default"])({}, k, {
    '& .alert__icon': {
      backgroundColor: data.background,
      color: data.colour,
      '&::before': {
        content: "\"".concat(data.icon, "\"")
      }
    }
  }));
}, {})));